// extracted by mini-css-extract-plugin
export default {"page":"LZ-z","cartModal":"MZ-z","checkout":"NZ-z","placeholder":"OZ-z","account":"PZ-z"};